import { useEffect, useState } from 'react'

import { authService } from '../services'

const useAuthToken = () => {
  const [data, setData] = useState<string>('')

  useEffect(() => {
    getUserCurrentToken()
  }, [])

  const getUserCurrentToken = () => {
    setData(authService.getUserCurrentTokenStorage())
  }

  const getUserTokenById = async (userId: string) => {
    const resp: any = await authService.getUserTokenById(userId)
    if(typeof resp.data === 'object') {
      setData(resp?.data?.token ? resp.data.token : '');
    } else {
      setData(resp)
    }
  }

  return {
    data,
    getUserTokenById
  }
}

export { useAuthToken }